export default function render(item) {
	const { url, term } = item;

	return `<a href="${url}" class="autocomplete-results-list__link clearfix" data-tagging="recentSearch">
		<span class="autocomplete-results-list__title">${term}</span>
		<svg class="autocomplete-results-list__search" aria-hidden="true"><use xlink:href="#icnMagnifierNew" /></svg>
	</a>`;
}
